/* eslint-disable @typescript-eslint/no-explicit-any */
// error-modal.component.ts
import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { ErrorModalService, AsyncModalData } from '../../services/error-modal.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
  imports: [CommonModule],
  standalone: true,
})
export class ErrorModalComponent implements AfterViewInit, OnDestroy {
  private elementSubject = new BehaviorSubject<ElementRef | undefined>(undefined);
  @ViewChild('htmlContentContainer', { static: false }) set htmlContentContainer(elementRef: ElementRef | undefined) {
    this.elementSubject.next(elementRef);
  }

  isModalOpen = false;
  private modalContainer: any;
  private subscription!: Subscription;
  private isAsyncModal = false;

  modalTitle = '';
  closeButtonLabel: string | undefined = '';
  saveButtonLabel: string | undefined = '';
  content = '';
  url!: string | undefined;
  htmlContent: HTMLElement | undefined;

  constructor(private elementRef: ElementRef, private modalService: ErrorModalService, private router: Router) {}

  ngAfterViewInit(): void {
    this.subscribeToHtmlElement();
    this.modalContainer = this.elementRef.nativeElement.querySelector('.modal-background');

    this.subscription = this.modalService.showModal$.subscribe((data: AsyncModalData | undefined) => {
      if (data) {
        this.modalTitle = data.title;
        this.closeButtonLabel = data.closeButtonLabel;
        this.saveButtonLabel = data.saveButtonLabel;
        this.content = data.content;
        this.isModalOpen = true;
        this.url = data.url;
        this.isAsyncModal = data.isAsync || false;
        this.htmlContent = data.htmlContent;
      } else {
        this.isModalOpen = false;
        this.isAsyncModal = false;
      }
    });
  }

  subscribeToHtmlElement(): void {
    this.elementSubject.pipe(filter((element) => element !== undefined)).subscribe((element) => {
      this.clearAndAppendHtmlElementToContainer(element.nativeElement);
    });
  }

  private clearAndAppendHtmlElementToContainer(container: HTMLElement): void {
    if (!this.htmlContent) return;
    container.innerHTML = '';
    container.appendChild(this.htmlContent);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeModal(): void {
    if (this.isAsyncModal) {
      this.modalService.resolveModal(false);
    } else {
      this.isModalOpen = false;
      this.modalService.closeModal();
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this.modalContainer && !this.modalContainer.contains(event.target)) {
      this.closeModal();
    }
  }

  saveChanges(): void {
    if (this.isAsyncModal) {
      this.modalService.resolveModal(true);
    } else {
      this.modalService.closeModal();
    }
  }

  goTo(): void {
    if (this.url) {
      if (this.url.includes('http')) window.open(this.url);
      else this.router.navigate([this.url ?? '/']);
    }

    if (this.isAsyncModal) {
      this.modalService.resolveModal(true);
    } else {
      this.modalService.closeModal();
    }
  }
}
